import mutations from "@/modules/sites/store/mutations";
import getters from "@/modules/sites/store/getters";
import actions from "@/modules/sites/store/actions";

export default {
    state: {},
    actions: actions,
    getters: getters,
    mutations: mutations
}